
const DEFAULT_STRUCTURE = {
  mainHeader: "פעילות חדשה",
  language: "he",
  sections: [],
};

const DEFAULT_SECTION = {
  header: "יחידה חדשה",
  elements: [],
};

const DEFAULT_ELEMENT = {
  type: "label",
};

const DEFAULT_MULTICHOICE_OPTION = {
  text: "",
};

export {
  DEFAULT_STRUCTURE,
  DEFAULT_SECTION,
  DEFAULT_ELEMENT,
  DEFAULT_MULTICHOICE_OPTION,
};
